<div class="history-panel">
  <div class="history-panel-title">{{'EVENTS' | translate}}</div>

  <div class="history-panel-expander">
    <a (click)="expandOrCollapseAll(!expand)"
       class="history-expander-btn">{{ (expand ? 'RECORDS_LIST.COLLAPSE' : 'RECORDS_LIST.EXPAND') | translate}}</a>
  </div>
  <div class="history-panel-type-dropdown">
    <div class="history-panel-type-dropdown-label">{{'SHOW' | translate}}</div>
    <cc-record-history-type [historyTypes]="availableHistoryTypes" [eventId]="eventId"
                            [contactId]="recordId"></cc-record-history-type>
  </div>
</div>

<ul class="history-timeline">
  <li class="history-timeline-header">
    <button class="history-timeline-btn-after"
            *ngIf="isAvailableMoreHistoryAfter()"
            (click)="prependHistory()">
      <i class="material-icons">keyboard_arrow_up</i>
    </button>
    <button class="history-timeline-btn-after end-of-history"
            *ngIf="!isAvailableMoreHistoryAfter()">
      <i class="material-icons">block</i>
    </button>
  </li>
  <li class="history-timeline-item" *ngFor="let event of history">
    <div class="history-timeline-item-wrap">
      <cc-box class="history-timeline-item-content">
        <span class="history-timeline-item-content-arrow"></span>
        <cc-history-header
          [date]="event.createdAt"
          [mainTitle]="getEventType(event)"
          [event]="event"
          [active]="isEventVisible(event.id)"
          [showIcon]="isDataInEvent(event)"
          (click)="toggleExpandEvent(event.id)" box header>
        </cc-history-header>
        <cc-history-body
          [event]="event"
          *ngIf="isDataInEvent(event) && visibleHistoryEvents[event.id]" box content>
        </cc-history-body>
      </cc-box>
    </div>
  </li>
  <li class="history-timeline-header">
    <button class="history-timeline-btn-before"
            *ngIf="isAvailableMoreHistoryBefore()"
            (click)="appendHistory()">
      <i class="material-icons">keyboard_arrow_down</i>
    </button>
    <button class="history-timeline-btn-before end-of-history"
            *ngIf="!isAvailableMoreHistoryBefore()">
      <i class="material-icons">block</i>
    </button>
  </li>
  <a (click)="scrollTop()"
     class="history-timeline-scroll-top btn channels-button info-full">
    {{'TOP' | translate}}</a>
</ul>
